module.exports = {
  profile: {
    names: ['analyst', 'designer', 'manager', 'programmer'],
  },
};



// WEBPACK FOOTER //
// ./src/configs/js/config.js